var user = () => {
  return JSON.parse(localStorage.getItem('user'))
}

function clearLocalStorage () {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
}

function setUserLocalStorage (user) {
  localStorage.setItem('token', user.token)
  localStorage.setItem('user', JSON.stringify(user))
}

function getPermission () {
  return localStorage.getItem('permissions')
}

function getToken () {
  return localStorage.getItem('token')
}

function getLanguage () {
  return localStorage.getItem('i18n') ? JSON.parse(localStorage.getItem('i18n')).code : 'en'
}

function replaceHtml (string = '') {
  string = string.replace('<br/>', '')
  string = string.replace('&nbsp;', '')
  string = string.replace('<p></p>', '')
  string = string.replace('/\t/g', '')
  string = string.replace('/\b/g', '')
  string = string.replace('/\r/g', '')
  string = string.replace('/\n/g', '')
  string = string.replace('/\f/g', '')
  return string
}

// No children []
function recursiveDocItem (arr, parent) {
  var out = []
  for (var i in arr) {
    if (arr[i].parent_id === parent) {
      var children = this.recursiveDocItem(arr, arr[i].id)
      if (children.length) {
        arr[i].children = children
      } else {

      }
      out.push(arr[i])
    }
  }
  return out
}
function getNestedChildren (arr, parent) {
  var out = []
  for (var i in arr) {
    if (arr[i].parent_id === parent) {
      var children = this.getNestedChildren(arr, arr[i].id)
      if (children.length) {
        arr[i].children = children
      } else {
        arr[i].children = []
      }
      out.push(arr[i])
    }
  }
  return out
}
function getUnNestedChildren (object = {}) {
  // object = Object.assign({}, object)
  var outs = [object]
  if (object.children) {
    for (var i = 0; i < object.children.length; i++) {
      outs = this.arrayUnique(outs.concat(outs.concat(object.children[i], this.getUnNestedChildren(object.children[i]))))
    }
  }
  return outs
}

function arrayUnique (array) {
  var a = array.concat()
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i].id === a[j].id) { a.splice(j--, 1) }
    }
  }
  return a
}

export default { user, setUserLocalStorage, clearLocalStorage, getToken, getLanguage, replaceHtml, getPermission, getNestedChildren, getUnNestedChildren, arrayUnique, recursiveDocItem }



// WEBPACK FOOTER //
// ./src/Helper.js